import type { DeviceInclude_Enum } from '@weave/schema-gen-ts/dist/schemas/phone/devices/v2/devices.pb';

export const devicesQueryKeys = {
  base: ['phone'],
  // include/tenantId are part of the key since different callers request different fields for the same locationIds
  listDevices: ({
    locationIds,
    include = [],
    tenantId = '',
  }: {
    locationIds: string[];
    include?: DeviceInclude_Enum[];
    tenantId?: string;
  }) => [...devicesQueryKeys.base, 'devices', { locationIds, include, tenantId }],
  unlockProvisioning: () => [...devicesQueryKeys.base, 'unlock-provisioning'],
  getDevice: (id: string) => [...devicesQueryKeys.base, 'get-device', id],
};
